import { mock } from "../configs";
import { sleep } from "../business/helpers/util";
import { errorTypes } from "../business/constants";
import axios from "axios";

export const fetchApi = async ({
  url,
  param = {},
  formData = null,
  mockData = false,
  headers = {},
  method = "POST",
}) => {
  let response;
  if (!url && !mockData) return null;

  if (mock.useMockData && mockData) {
    await sleep(mock.mockFetchDuration);
    response = mockData;
  } else {
    response = await apiCall({ url, param, formData, method, headers });
  }
  return response;
};

const apiCall = async ({ url, param, formData, headers, method }) => {
  let options = {
    method,
    referrer: "",
    headers: {
      ...headers,
      Accept: "application/json",
    },
    body:
      method === "GET"
        ? undefined
        : formData
        ? formData
        : JSON.stringify(param),
  };

  if (!formData) {
    options.headers["Content-Type"] = "application/json";
  }

  let fullUrl = url.includes("://")
    ? url
    : `${process.env.REACT_APP_API_BASE}${url}`;
  fullUrl = fullUrl.replace(/\/\s*$/, "");
  // fullUrl += '?key=' + process.env.REACT_APP_API_KEY

  const response = await fetch(fullUrl, options).catch(handleErr);
  const success =
    response.status && response.status >= 200 && response.status < 300;
  const result = await response
    .json()
    .catch((err) => handleErrJson(err, success));

  return Promise.resolve(result);
};
const handleErr = (err) => {
  console.warn(err);
  return new Response(
    JSON.stringify({
      err: errorTypes.network,
      message: err.message,
    })
  );
};

const handleErrJson = (err, success) => {
  console.warn(err);
  return success
    ? new Response(
        JSON.stringify({
          success: true,
        })
      ).json()
    : new Response(
        JSON.stringify({
          err: errorTypes.network,
          message: err.message,
        })
      ).json();
};

export const baseAxios = () =>
  axios.create({
    baseURL: "https://stage.roadway-moving-ny.com/api",
    // baseURL: "https://roadway-backend.test/api",
    // baseURL: process.env.REACT_APP_API_BASE,
    // timeout: 700,
    headers: {
      Accept: "application/json",
      // Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

/**
 * Storage Expected Income API functions
 */

/**
 * Get Storage Expected Income report
 * @returns {Promise<Array>} Array of report items
 */
export const getStorageExpectedIncome = async () => {
  try {
    const axiosInstance = baseAxios();
    const response = await axiosInstance.get(
      "/storage-v2/storage-expected-income",
      {
        params: {
          wReport: "Storage_Expected_Income",
        },
      }
    );

    if (response.data?.body?.report) {
      return response.data.body.report;
    }
    return [];
  } catch (error) {
    console.error("Error fetching Storage Expected Income:", error);
    throw error;
  }
};

/**
 * Get Storage Expected Income First Charges report
 * @param {boolean} manual - If true, uses manual flag in request
 * @param {string} monthType - Type of month: 'current' or 'next' (optional)
 * @returns {Promise<Array>} Array of report items
 */
export const getStorageExpectedIncomeFirstCharges = async (
  manual = false,
  monthType = null
) => {
  try {
    const axiosInstance = baseAxios();
    const params = manual
      ? {
          manual: true,
        }
      : {
          wReport: "Storage_Expected_Income_First_Charges",
        };

    // Add month type parameter if provided
    if (monthType) {
      params.monthType = monthType;
    }

    const response = await axiosInstance.get(
      "/storage-v2/storage-expected-income",
      {
        params,
      }
    );

    if (response.data?.body?.report) {
      return response.data.body.report;
    }
    return [];
  } catch (error) {
    console.error(
      "Error fetching Storage Expected Income First Charges:",
      error
    );
    throw error;
  }
};

/**
 * Get V.Santini Storage report
 * @returns {Promise<Array>} Array of report items
 */
export const getVSantiniStorage = async () => {
  try {
    const axiosInstance = baseAxios();
    const response = await axiosInstance.get(
      "/storage-v2/storage-expected-income",
      {
        params: {
          wReport: "V_Santini_Storage",
        },
      }
    );

    if (response.data?.body?.report) {
      return response.data.body.report;
    }
    return [];
  } catch (error) {
    console.error("Error fetching V.Santini Storage:", error);
    throw error;
  }
};
